export default {"src":"/_next/static/media/icon-reward-vesting.a2f94e22.svg","height":32,"width":35,"blurWidth":0,"blurHeight":0};